<template>

</template>

<script>
export default {
  name: "kg"
}
</script>

<style scoped>

</style>
